<template>
  <div class="tree-dialog-home">
    <el-dialog
      :title="title"
      :visible.sync="treeVisible"
      width="620px"
      class="upload-data-dialog-box"
      @close="treeIconClose"
      :modal="modal"
    >
      <div class="tree-dialog-box" v-loading="dialogLoading">
        <div class="tree-dialog-item-box">
          <div class="tree-search-box" v-if="!isMetrics">
            <el-input
              v-sensitive-words
              v-model.trim="searchVal"
              :placeholder="
                treeType === '3'
                  ? '请输入角色名称'
                  : treeType === '1'
                  ? '请输入岗位名称或编码'
                  : '请输入岗位名称或员工姓名'
              "
              @keyup.enter.native="search"
              :maxlength="50"
              clearable
              @clear="search"
            ></el-input>
            <span @click="search">搜索</span>
          </div>
          <div class="tree-dialog-list-box" v-loading="treeLoading">
            <TreeBoxNew
              :list="treeList"
              :actChildIds="treeChildIdList"
              :deptIds="treeDeptIds"
              :userIds="treeUserIds"
              :activeList="treeActiveList"
              :isSelectMutiDeptInOneUser="isSelectMutiDeptInOneUser"
              :isLazyLoading="lazyLoading"
              :loadChildrenName="leafName"
              :disabledKey="disabledKeyName"
              :disableList="disableList"
              @itemClick="treeItemClick"
              @iconClick="treeIconClick"
              v-if="treeList.length && treeList.length > 0"
            />
            <div class="tree-dialog-list-no-data" v-else>暂无数据</div>
          </div>
        </div>
        <div class="tree-dialog-item-box">
          <!-- 是否可以导入 -->
          <div class="import-box" v-if="isImport">
            <uploadFile
              ref="refUploadFile"
              btnType="null"
              :accept="['.xlsx', '.xls']"
              :businessName="uploadFileEnum.EXAM"
              @startUpload="dialogLoading = true"
              @uploadError="dialogLoading = false"
              @uploadSuccess="uploadSuccess"
              text="批量导入"
              :maxSize="50"
              :maxFileCount="1"
            ></uploadFile>
            <el-button style="margin-left: 8px" @click="downloadTemplate"
              >下载模板</el-button
            >
          </div>
          <div class="tree-dialog-item-right-box">
            <div
              class="tree-dialog-right-item-box"
              v-for="(item, index) in treeActiveList"
              :key="item.type === 1 ? 'dept_' + item.id : item.id"
            >
              <span
                class="tree-dialog-right-item-name"
                :class="
                  disableId(item) ? 'tree-dialog-right-item-disable-label' : ''
                "
              >
                {{ item.label }}
              </span>
              <span
                class="tree-dialog-right-item-delete"
                :class="
                  disableId(item) ? 'tree-dialog-right-item-disable-icon' : ''
                "
                @click="treeIconDelete(item, index)"
              >
                <i class="el-icon-close"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isShowHistory" class="extra-options">
        <span>关联历史客户</span>
        <el-switch v-model="isTakeCustomerData" />
      </div>
      <div slot="footer">
        <el-button @click.native="treeIconClose">取消</el-button>
        <el-button
          type="primary"
          @click.native="treeIconSave"
          :loading="isLoading"
           v-throttle>确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import TreeBoxNew from '@/components/TreeBoxNew/index';
  import {
    getStructureEnterpriseV2,
    getStructureUsersV2,
    getStructureV2SearchKeyWord
  } from '@/api/common';
  import { fetchRolesStructure, uploadAttendee } from '@/api/role';
  import uploadFile from '@/components/uploadAllTypeFile/upload-file';
  import { uploadFileEnum } from '@/utils/auth';
  import { getTree } from '@/api/indicator.js';
  import { downUrlName } from '@/utils/data-update';

  export default {
    components: {
      TreeBoxNew,
      uploadFile
    },
    props: {
      isImport: {
        type: Boolean,
        default: false
      },
      modal: {
        type: Boolean,
        default: true
      },
      title: {
        type: String,
        default: '组织架构'
      },
      activeList: {
        type: Array,
        default: () => []
      },
      activeUserIds: {
        type: Array,
        default: () => []
      },
      activeDeptIds: {
        type: Array,
        default: () => []
      },
      enterpriseId: {
        type: [String, Number],
        default: ''
      },
      // 是否多选
      isMultiple: {
        type: Boolean,
        default: true
      },
      // 是否开启懒加载
      lazyLoading: {
        type: Boolean,
        default: true
      },
      // 控制懒加载字段
      leafName: {
        type: String,
        default: 'expanded'
      },
      // 类型：1-部门；2-部门和人  3-角色
      treeType: {
        type: String,
        default: '2'
      },
      // 是否只选人
      isSelectPerson: {
        type: Boolean,
        default: false
      },
      // 一人多岗下选人，是否将所有岗位下的人都选中，目前只有加签需要true
      isSelectMutiDeptInOneUser: {
        type: Boolean,
        default: false
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      //判断禁用key名
      disabledKeyName: {
        type: String,
        default: ''
      },
      editDisable: {
        type: Boolean,
        default: false
      },
      isShowHistory: {
        type: Boolean,
        default: false
      },
      takeCustomerData: {
        type: Boolean,
        default: true
      },
      // 禁用id列表
      disableList: {
        type: Array,
        default: () => []
      },
      maxNumber: {
        type: Number,
        default: 0
      },
      // 会议权限:MY_DEPARTMENT-本辖区及下级辖区；ALL_DEPARTMENT-全部辖区
      scope: {
        type: String,
        default: ''
      },
      isMetrics: {
        type: Boolean,
        default: false
      },
      //是否限制选中层级
      isLevel: {
        type: Boolean,
        default: false
      },
      //限制的选中层级
      level: {
        type: Number,
        default: 0
      },
      //账期年月时间戳
      selectedYearMonth: {
        default: ''
      }
    },

    data() {
      return {
        uploadFileEnum,
        uploading: false,
        treeLoading: false,
        treeVisible: false,
        dialogLoading: false,
        treeActiveList: [],
        treeDeptIds: [],
        treeUserIds: [],
        treeList: [],
        treeChildIdList: [],
        searchVal: '',
        isSearch: false,
        isTakeCustomerData: this.takeCustomerData
      };
    },

    methods: {
      downloadTemplate() {
        window.open(
          downUrlName +
            'download_template/%E9%97%AE%E5%8D%B7%E5%A1%AB%E5%86%99%E4%BA%BA%E5%91%98-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
        );
      },
      async uploadSuccess(obj) {
        try {
          const res = await uploadAttendee({
            fileUrl: obj.url
          });

          res.forEach((item) => {
            if (!this.treeUserIds.includes(item.id)) {
              this.treeUserIds.push(item.id);
              this.treeActiveList.push(item);
            }
          });

          this.treeUserIds = JSON.parse(JSON.stringify(this.treeUserIds));
          this.treeActiveList = JSON.parse(JSON.stringify(this.treeActiveList));

          this.$emit(
            'update:activeList',
            JSON.parse(JSON.stringify(this.treeActiveList))
          );

          this.$message.success('导入成功');
          this.dialogLoading = false;
        } catch (error) {
          this.dialogLoading = false;
          this.Sentry.captureException(error);
        }
      },
      disableId(val) {
        if (this.disableList?.length) {
          return this.disableList.some((item) => {
            if (item.type === val.type && item.id === val.id) {
              return true;
            }
            return false;
          });
        }
        return false;
      },
      async open() {
        this.dialogLoading = true;
        this.treeVisible = true;
        try {
          await this.init();
          console.log(this.activeList);
          if (this.activeList?.length > 0) {
            let activeList = JSON.parse(JSON.stringify(this.activeList));

            this.treeActiveList = activeList;
          }
          if (this?.activeDeptIds?.length > 0) {
            this.treeDeptIds = JSON.parse(JSON.stringify(this.activeDeptIds));
          }
          if (this?.activeUserIds?.length > 0) {
            this.treeUserIds = JSON.parse(JSON.stringify(this.activeUserIds));
          }
          this.dialogLoading = false;
        } catch (e) {
          this.dialogLoading = false;
          this.Sentry.captureException(e);
        }
      },
      async init() {
        try {
          let res;
          if (this.treeType === '3') {
            res = await fetchRolesStructure({
              name: this.searchVal || null
            });
          } else {
            if (this.isMetrics) {
              res = await getTree({
                type: this.treeType
              });
            } else {
              res = await getStructureEnterpriseV2({
                enterpriseId: this.enterpriseId || null,
                type: this.treeType,
                scope: this.scope || undefined,
                keyword: this.searchVal || undefined,
                yearMonth: this.selectedYearMonth || ''
              });
            }
          }

          this.treeList = res;
          // if (this.searchVal) {
          this.formatTreeList(this.treeList);
          // }
        } catch (error) {
          this.treeLoading = false;
          this.Sentry.captureException(error);
        }
      },
      formatTreeList(list) {
        if (list.length === 0) {
          return;
        } else {
          list.map((item) => {
            if (item.type === 1 && item.children && item.children.length > 0) {
              if (this.searchVal) {
                this.treeIconClick(item, 'IS_SEARCH');
              }
              this.formatTreeList(item.children);
            }
            if (
              this.searchVal &&
              item.label &&
              item.label.indexOf(this.searchVal) > -1
            ) {
              const regex = new RegExp(this.searchVal, 'gi');
              const result = item.label.replace(regex, (match) => {
                return `<span style="color:#1ab370">${match}</span>`;
              });
              item.labelHtml = result;
            } else {
              item.labelHtml = `<span>${item.label}</span>`;
            }
          });
        }
      },
      // 加载部门
      async treeIconClick(val, initExpanded) {
        if (
          this.treeChildIdList.indexOf(val.id) !== -1 &&
          initExpanded != 'IS_SEARCH'
        ) {
          this.treeChildIdList.splice(this.treeChildIdList.indexOf(val.id), 1);
        } else {
          if (val?.children?.length > 0) {
            if (!this.treeChildIdList.includes(val.id)) {
              this.treeChildIdList.push(val.id);
            }

            return;
          }
          this.$set(val, 'loading', true);
          try {
            let res;
            if (this.isMetrics) {
              res = await getTree({
                enterpriseId: this.enterpriseId || null,
                deptId: val.id,
                type: this.treeType
              });
            } else {
              res = await getStructureEnterpriseV2({
                enterpriseId: this.enterpriseId || null,
                deptId: val.id,
                type: this.treeType,
                scope: this.scope || undefined,
                yearMonth: this.selectedYearMonth || ''
              });
            }
            this.$set(val, 'loading', false);
            this.$set(val, 'children', res);
            if (!this.treeChildIdList.includes(val.id)) {
              this.treeChildIdList.push(val.id);
            }
            this.formatTreeList(this.treeList);
          } catch (e) {
            this.$set(val, 'loading', false);
            this.Sentry.captureException(e);
          }
        }
      },
      // 选择部门、人
      treeItemClick(val) {
        console.log(val);

        if (this.isLevel) {
          if (val.level != this.level) {
            return;
          }
        }
        if (this.editDisable || this.disableId(val)) {
          return;
        }
        try {
          if (this.listNameFilter(val)) {
            // 已选删除
            if (this.listNameFilter(val).indexOf(val.id) !== -1) {
              this.listNameFilter(val).splice(
                this.listNameFilter(val).indexOf(val.id),
                1
              );
              this.treeActiveList = this.treeActiveList.filter((item) => {
                if (
                  (this.treeType === '3' || val.type === item.type) &&
                  val.id === item.id
                ) {
                  return false;
                } else {
                  return true;
                }
              });
            } else {
              // 多选
              if (this.isMultiple) {
                if (
                  this.maxNumber &&
                  this.treeActiveList.length >= this.maxNumber
                ) {
                  return;
                }

                // 只选部门 和 角色查询
                if (this.treeType === 1 || this.treeType === '3') {
                  this.treeDeptIds.push(val.id);
                  this.treeActiveList.push(val);
                } else {
                  // 只选人
                  if (this.isSelectPerson) {
                    if (val.type === 2) {
                      this.treeUserIds.push(val.id);
                      this.treeActiveList.push(val);
                    }
                  } else {
                    // 选部门+人
                    this.listNameFilter(val).push(val.id);
                    this.treeActiveList.push(val);
                  }
                }
              } else {
                // 只选部门 和 角色查询
                if (this.treeType === 1 || this.treeType === '3') {
                  this.treeDeptIds = [val.id];
                  this.treeActiveList = [val];
                } else {
                  // 只选人
                  if (this.isSelectPerson) {
                    if (val.type === 2) {
                      this.treeUserIds = [val.id];
                      this.treeActiveList = [val];
                    }
                  } else {
                    // 选部门+人
                    this.treeUserIds = [];
                    this.treeDeptIds = [];
                    this.listNameFilter(val).push(val.id);
                    this.treeActiveList = [val];
                  }
                }
              }
            }
          }
        } catch (error) {
          if (error?.message) {
            this.$message.error(error.message);
          }
          this.Sentry.captureException(error);
        }
      },
      // 删除部门、人
      treeIconDelete(val, index) {
        if (this.editDisable || this.disableId(val)) {
          return;
        }
        try {
          if (this.listNameFilter(val)) {
            this.listNameFilter(val).splice(
              this.listNameFilter(val).indexOf(val.id),
              1
            );
            this.treeActiveList.splice(index, 1);
          }
        } catch (error) {
          if (error?.message) {
            this.$message.error(error.message);
          }
          this.Sentry.captureException(error);
        }
      },
      treeIconClose() {
        this.treeVisible = false;
        this.treeUserIds = [];
        this.treeDeptIds = [];
        this.treeActiveList = [];
        this.treeChildIdList = [];
        this.treeList = [];
        this.searchVal = '';
        this.isSearch = false;

        if (this.isShowHistory) {
          this.isTakeCustomerData = this.takeCustomerData;
        }

        this.$emit('close');
      },
      treeIconSave() {
        // 更新父组件对应值
        this.$emit('update:activeUserIds', this.treeUserIds);
        this.$emit('update:activeDeptIds', this.treeDeptIds);
        this.$emit('update:activeList', this.treeActiveList);
        // 展示'关连历史客户'时
        if (this.isShowHistory) {
          this.$emit('updateTakeCustomerData', this.isTakeCustomerData);
        }
        // 保存时是否发起请求
        if (this.$listeners['saveClose']) {
          /* 
        时机: 点击保存或确定时触发
        参数：1、当前选中对象的集合；2、选中部门id集合；3、选中人id集合
        */
          this.$emit(
            'saveClose',
            this.treeActiveList,
            this.treeDeptIds,
            this.treeUserIds
          );
        } else {
          this.treeIconClose();
        }
      },
      // 过滤选中数组
      listNameFilter(val) {
        if (val.type == 1 || this.treeType === '3') {
          return this.treeDeptIds;
        } else if (val.type == 2) {
          return this.treeUserIds;
        } else {
          throw new Error('当前组织架构‘type’字段值异常：' + val.type);
        }
      },
      async search() {
        this.treeLoading = true;
        this.treeList = [];
        if (this.searchVal && this.treeType != '3') {
          this.isSearch = true;
          await this.init();
        } else {
          this.isSearch = false;
          this.treeChildIdList = [];
          await this.init();
        }
        this.treeLoading = false;
      },
      async getStructureUsers() {
        this.dialogLoading = true;

        try {
          if (this.treeType === '1') {
            const data = await getStructureV2SearchKeyWord({
              keyWord: this.searchVal,
              enterpriseId: this.enterpriseId || null,
              scope: this.scope || undefined
            });
            this.treeList = data;
          } else {
            const data = await getStructureUsersV2({
              userName: this.searchVal,
              enterpriseId: this.enterpriseId || null,
              scope: this.scope || undefined
            });
            this.treeList = data.map((item) => {
              const deptName =
                item.departs.find((d) => {
                  return d.wechatDeptId === item.departmentId;
                })?.wechatDeptName || '';
              return {
                deptName,
                type: 2,
                id: item.id,
                departmentId: item.departmentId,
                label: item.userName
              };
            });
          }

          this.dialogLoading = false;
        } catch (error) {
          this.dialogLoading = false;
          this.Sentry.captureException(error);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .tree-dialog-home {
    .tree-dialog-box {
      display: flex;
      align-items: center;
      height: 50vh;
      .tree-dialog-item-box {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 100%;
        border: 1px solid #eeeeee;
        border-radius: 4px;
        overflow: hidden;
        .import-box {
          height: 56px;
          display: flex;
          align-items: center;
          padding: 0 16px;
          ::v-deep .el-button {
            color: #1ab370;
          }
        }
        &:first-child {
          margin-right: 20px;
        }
        .tree-dialog-list-box,
        .tree-dialog-item-right-box {
          width: 100%;
          height: 100%;
          padding: 0 16px;
          overflow: auto;
          .tree-dialog-list-no-data {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 50px;
            font-size: 14px;
            color: #c6c6c6;
          }
        }
        .tree-dialog-list-box,
        .tree-dialog-item-right-box {
          &::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }

          &::-webkit-scrollbar-track {
            background: rgb(239, 239, 239);
            border-radius: 2px;
          }

          &::-webkit-scrollbar-thumb {
            background: #bfbfbf;
            border-radius: 8px;
          }

          &::-webkit-scrollbar-thumb:hover {
            background: #999;
          }

          &::-webkit-scrollbar-corner {
            background: #efefef;
          }
        }
        .tree-dialog-item-right-box {
          .tree-dialog-right-item-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 0;
            .tree-dialog-right-item-name {
              // display: flex;
              word-break: break-all;
              margin-right: 10px;
            }
            .tree-dialog-right-item-delete {
              cursor: pointer;
            }
            .tree-dialog-right-item-disable-icon {
              cursor: not-allowed;
              color: #c0c4cc;
            }
            .tree-dialog-right-item-disable-label {
              color: #c0c4cc;
            }
          }
        }
        .tree-search-box {
          display: flex;
          align-items: center;
          padding: 20px 16px 0;

          > span {
            width: 56px;
            text-align: center;
            cursor: pointer;
            color: $--color-primary;
          }
        }
      }
    }
    .extra-options {
      padding-top: 14px;

      span {
        padding-right: 16px;
      }
    }
    ::v-deep {
      .el-dialog__header {
        padding-top: 18px;
        padding-bottom: 14px;
      }
      .el-dialog__body {
        padding: 16px !important;
      }
    }
  }
</style>
